import { Button, Grid } from '@mui/material'

import addPhotoImage from '../../images/add-photo.png'
import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

interface IProps {
  hasPhoto: boolean
  photoPath: string | null
  handleShowDevicePhotoModal: () => void
}

const DevicePhotoThumbnail = (props: IProps) => {
  const { hasPhoto, photoPath, handleShowDevicePhotoModal } = props

  const classes = useStyles
  const sharedClasses = useSharedStyles

  return hasPhoto && photoPath ? (
    <Grid container={true} spacing={1} sx={[sharedClasses.centerContentVertical, { marginTop: 1 }]}>
      <Grid>
        <img src={photoPath} alt="Photo of device" style={classes.thumbnail} />
      </Grid>
      <Grid>
        <Button variant="text" size="small" sx={classes.photoBtn} onClick={handleShowDevicePhotoModal}>
          Change Photo
        </Button>
      </Grid>
    </Grid>
  ) : (
    <Grid container={true} spacing={1} sx={[sharedClasses.centerContentVertical, { marginTop: 1 }]}>
      <Grid>
        <img src={addPhotoImage} alt="No photo" />
      </Grid>
      <Grid>
        <Button variant="text" size="small" sx={classes.photoBtn} onClick={handleShowDevicePhotoModal}>
          Add Photo
        </Button>
      </Grid>
    </Grid>
  )
}

export default DevicePhotoThumbnail
